var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import analytics from '@viewlift/analytics/analytics-core/index.cjs';
import googleAnalytics from '@viewlift/analytics/google-analytics/index.cjs';
import userBeacon from '@viewlift/analytics/user-beacon/index.cjs';
import fbPixel from '@viewlift/analytics/facebook/index.cjs';
import { getToken } from "../helpers";
export default function trackEvent(eventName, payload, gaId) {
    var _a, _b, _c;
    var commonPayload = {
        platform: 'Web'
    };
    if (typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.app_data)) {
        var trackingID = gaId || ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.googleAnalyticsId);
        analytics({
            app: 'analytics',
            eventName: eventName,
            plugins: [
                googleAnalytics({
                    trackingId: trackingID,
                    initialize: function () {
                        console.log('FIRE INIT FROM PLUGIN X');
                    },
                    payload: __assign(__assign({}, payload), commonPayload)
                }),
            ]
        });
    }
    else {
        console.log("Analytics Tracking is supported on client side only");
    }
}
export function trackUserEvent(payload) {
    if (typeof window !== 'undefined') {
        return analytics({
            app: 'user-analytics',
            apiBaseUrl: window['analyticsBaseUrl'],
            plugins: [
                userBeacon({
                    initialize: function () {
                        console.log('FIRE INIT FROM PLUGIN USER');
                    },
                    payload: payload
                }),
            ]
        });
    }
    else {
        console.log("Analytics Tracking is supported on client side only");
    }
}
export function trackFbEvent(eventName, payload) {
    var _a, _b, _c;
    var conversionApi = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.conversionApi;
    if (typeof window !== 'undefined') {
        getToken().then(function (token) {
            var _a, _b, _c, _d, _e, _f;
            analytics({
                app: 'fb-analytics',
                eventName: eventName,
                trackingBaseUrl: (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.trackingBaseUrl,
                apiBaseUrl: (_d = (_c = window === null || window === void 0 ? void 0 : window.app_data) === null || _c === void 0 ? void 0 : _c.appcmsMain) === null || _d === void 0 ? void 0 : _d.apiBaseUrl,
                eventType: "fbConversionAPI",
                platformDetails: {
                    site: (_f = (_e = window === null || window === void 0 ? void 0 : window.app_data) === null || _e === void 0 ? void 0 : _e.appcmsMain) === null || _f === void 0 ? void 0 : _f.internalName,
                    conversionApiEnabled: conversionApi === null || conversionApi === void 0 ? void 0 : conversionApi.conversionApi,
                    pixelId: conversionApi === null || conversionApi === void 0 ? void 0 : conversionApi.pixelID,
                    device: "web",
                    token: token
                },
                plugins: [
                    fbPixel({
                        initialize: function () {
                            console.log('FIRE INIT FROM PLUGIN FB Pixel');
                        },
                        payload: payload
                    }),
                ]
            });
        });
    }
    else {
        console.log("Analytics Tracking is supported on client side only");
    }
}
export function trackPixelEvent(eventName, payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var conversionApi = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.conversionApi;
    if (typeof window !== 'undefined') {
        analytics({
            app: 'fb-analytics',
            eventName: eventName,
            trackingBaseUrl: (_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.appcmsMain) === null || _e === void 0 ? void 0 : _e.trackingBaseUrl,
            apiBaseUrl: (_g = (_f = window === null || window === void 0 ? void 0 : window.app_data) === null || _f === void 0 ? void 0 : _f.appcmsMain) === null || _g === void 0 ? void 0 : _g.apiBaseUrl,
            eventType: "fbPixel",
            platformDetails: {
                site: (_j = (_h = window === null || window === void 0 ? void 0 : window.app_data) === null || _h === void 0 ? void 0 : _h.appcmsMain) === null || _j === void 0 ? void 0 : _j.internalName,
                conversionApiEnabled: conversionApi === null || conversionApi === void 0 ? void 0 : conversionApi.conversionApi,
                pixelId: conversionApi === null || conversionApi === void 0 ? void 0 : conversionApi.pixelID
            },
            plugins: [
                fbPixel({
                    initialize: function () {
                        console.log('FIRE INIT FROM PLUGIN FB Pixel');
                    },
                    payload: payload
                }),
            ]
        });
    }
    else {
        console.log("Analytics Tracking is supported on client side only");
    }
}
